<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-20">
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <div class="container">
          <div class="px-4 gap-4">
            <p class="mb-4">
              Enter your new password in both of the fields and click the Reset Password
              button below, this will set your password and you should use this new
              password to login going forwards.
            </p>
            <p class="mb-4">
             Passwords must be at least 8 characters and contain at least one uppercase character, one number and one special character
            </p>
          </div>
          <form class="px-4 flex flex-wrap gap-4" @submit.prevent autocomplete="off">
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/3">
                <label for="password" class="font-semibold text-brand-blue-400"
                  >New Password</label
                >
              </div>
              <div class="w-2/3">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="password"
                  type="password"
                  v-model="form.password"
                  autocomplete="off"
                />
              </div>
              <div
                v-if="$attrs.errors.password"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm mt-4"
              >
                {{ $attrs.errors.password }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/3">
                <label for="password" class="font-semibold text-brand-blue-400"
                  >Confirm New Password</label
                >
              </div>
              <div class="w-2/3">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="password"
                  type="password"
                  v-model="form.password_confirmation"
                  autocomplete="off"
                />
              </div>
              <div
                v-if="$attrs.errors.password_confirmation"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm mt-4"
              >
                {{ $attrs.errors.password_confirmation }}
              </div>
            </div>
            <div class="flex justify-end w-full">
              <button
                class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold py-2 px-4 mr-2 rounded uppercase"
                @click="form.post('/reset-password', { preserveState: true })"
              >
                Reset password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";

export default {
  components: {
    PageHeader,
  },
  name: "ResetPassword",
  setup() {
    const url = new URL(
      document.location.protocol + "//" + document.location.hostname + Inertia.page.url
    );
    const form = useForm({
      password: "",
      password_confirmation: "",
      email: url.searchParams.get("email"),
      token: url.searchParams.get("token"),
    });
    const headingContent = {
      hero: {
        image: "/images/263918963_cars_hero.jpg",
        title: "Fleet Risk Review",
        subtitle: "In association with AXA Insurance",
      },
      page: {
        title: "Reset Your Password",
        subtitle: " ",
      },
    };
    return {
      form,
      headingContent,
    };
  },
};
</script>
